module.exports = __webpack_public_path__ + "files/9316669710349de754315a7d8223ddba.png";